import React from 'react';
import { CtaProps } from 'src/modules/global/components/cta/Cta';
import { LinkWithIcon } from 'src/modules/products/components/downloads/LinkWithIcon/LinkWithIcon';
import { GlobalIcon, IconImage } from 'src/modules/global';
import styles from './LayoutCardDownload.module.scss';
import { Channel } from 'src/modules/locale/utils';

export type LayoutCardDownloadData = {
  text_image_card_download_channel: Channel;
  copy: string;
  cta_1: CtaProps;
  cta_2: CtaProps;
  image: {
    url: string;
  };
  title: string;
};

export type LayoutCardDownloadProps = {
  data: LayoutCardDownloadData;
};

const LayoutCardDownload = (props: LayoutCardDownloadProps) => {
  const { data } = props;

  if (!data?.image?.url) return null;

  return (
    <div>
      <img className={styles.image} src={data.image.url} />
      <h3 className={styles.title}>{data.title}</h3>
      <p className={styles.paragraph}>{data.copy}</p>
      <div className={styles.links}>
        {data?.cta_1?.download?.url && (
          <div className={styles.link}>
            <LinkWithIcon
              href={data.cta_1.download.url}
              icon={<GlobalIcon image={IconImage.Download} />}>
              {data.cta_1.text}
            </LinkWithIcon>
          </div>
        )}
        {data?.cta_2?.download?.url && (
          <div className={styles.link}>
            <LinkWithIcon
              href={data.cta_2.download.url}
              icon={<GlobalIcon image={IconImage.Download} />}>
              {data.cta_2.text}
            </LinkWithIcon>
          </div>
        )}
      </div>
    </div>
  );
};

export default LayoutCardDownload;
